import { createReducer, on } from '@ngrx/store';
import { PropertyActions } from './property.actions';
import { Property, Pagination } from '@core/interface/property';

export const PropertyFeatureKey = 'property';

export interface PropertyState {
  properties: Property[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: PropertyState = {
  properties: [],
  isLoading: true,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const PropertyReducer = createReducer(
  initialState,
  on(PropertyActions.loadProperties, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(PropertyActions.loadPropertiesSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    properties: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
  })),
  on(PropertyActions.loadPropertiesFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(PropertyActions.addPropertySuccess, (state, { data }) => ({
    ...state,
    properties: [...state.properties, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(PropertyActions.addPropertyFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(PropertyActions.updatePropertySuccess, (state, { data }) => ({
    ...state,
    properties: state.properties.map((Property) =>
      data.id == Property.id ? data : Property
    ),
    isDeleted: false,
    addEditError: null,
  })),
  on(PropertyActions.updatePropertyFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(PropertyActions.deletePropertySuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    properties: state.properties.filter((Property) => Property.id !== id),
  })),
  on(PropertyActions.deletePropertyFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(PropertyActions.deleteProperty, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(PropertyActions.resetData, (state) => ({
    ...state,
    isDeleted: false,
  })),
  on(PropertyActions.resetProperties, (state) => ({
    ...state,
    properties: [],
  }))
);
